/**
 * Polyfills for Qt 5.15's Chromium 87 (bundled in PyWebView AppImage).
 *
 * Qt 5.15 ships Chromium 87 which lacks some ES2022+ features used by
 * React, Zustand, and other dependencies. Import this before anything else.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

// Object.hasOwn — ES2022 (Chromium 93+)
if (!(Object as any).hasOwn) {
  (Object as any).hasOwn = (obj: object, key: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(obj, key);
}

// Array.prototype.at — ES2022 (Chromium 92+)
if (!(Array.prototype as any).at) {
  (Array.prototype as any).at = function (n: number) {
    n = Math.trunc(n) || 0;
    if (n < 0) n += this.length;
    return this[n];
  };
}

// structuredClone — Chromium 98+
if (typeof globalThis.structuredClone === "undefined") {
  (globalThis as any).structuredClone = <T>(val: T): T =>
    JSON.parse(JSON.stringify(val));
}

/* eslint-enable @typescript-eslint/no-explicit-any */
